import { PLAN_TYPES } from "./plans";

export function getCardStyles(plan, color, styles) {
  const shadowBase = "0 12px 40px";

  const cardStyle = {
    borderColor: color,
    boxShadow:
      plan === PLAN_TYPES.FAMILY
        ? `${shadowBase} rgba(245, 144, 16, 0.35)`
        : plan === PLAN_TYPES.PREMIUM
        ? `${shadowBase} rgba(9, 188, 193, 0.45)`
        : `${shadowBase} rgba(0, 0, 0, 0.25)`,
  };

  const badgeStyle = {
    backgroundColor:
      plan === PLAN_TYPES.FAMILY ? "orange" : "var(--mainColor)",
  };

  const buttonStyle = {
    backgroundColor:
      plan === PLAN_TYPES.FAMILY
        ? "orange"
        : plan === PLAN_TYPES.PREMIUM
        ? "var(--mainColor)"
        : "#eef9f8",
    color: plan === PLAN_TYPES.FREE ? color : "white",
    border: plan === PLAN_TYPES.FREE ? `2px solid ${color}` : "none",
  };

  const buttonClass = `
    ${styles.ctaBtn}
    ${plan === PLAN_TYPES.FAMILY ? styles.premiumPlusBtn : plan === PLAN_TYPES.PREMIUM ? styles.premiumBtn : styles.freeBtn}
  `;

  const cancelButtonStyle = {
    backgroundColor: "#ff4d4d",
    color: "white",
    border: "none",
    boxShadow: "0 6px 20px rgba(255, 77, 77, 0.35)",
  };

  return { cardStyle, buttonStyle, buttonClass, cancelButtonStyle, badgeStyle };
}